<template>
  <div class="change-major-form">
    <b-form @submit="submitForm" v-if="!formState.submitted">
      <template v-if="!isNew">
        <p>
          You have already submitted this form. If you would like to make
          changes, click the <strong>Edit</strong> button.
        </p>
        <b-form-group>
          <b-button
            :disabled="formState.submitting"
            :variant="formState.isEditing ? 'secondary' : 'primary'"
            :class="formState.isEditing ? '' : 'red'"
            @click="editing"
            >{{ !formState.isEditing ? "Edit" : "Cancel Editing" }}</b-button
          >
        </b-form-group>
      </template>
      <b-form-group label="New Major:">
        <b-form-select
          text="Change Major to:"
          :disabled="!formState.isEditing"
          :state="newMajorValidation.getState(formState.validate)"
          v-model="formData.newMajor"
          :options="changeMajorOptionsValue"
        >
        </b-form-select>
        <b-form-invalid-feedback
          :state="newMajorValidation.getState(formState.validate)"
          >You must enter your new major</b-form-invalid-feedback
        >
      </b-form-group>
      <b-form-group
        label="Other College:"
        v-if="formData.newMajor === 'Other College'"
      >
        <b-form-select
          text="Change College To:"
          :disabled="!formState.isEditing"
          :state="otherCollegeValidation.getState(formState.validate)"
          v-model="formData.otherCollege"
          :options="changeCollegeOptionsValue"
        >
        </b-form-select>
        <b-form-invalid-feedback
          :state="otherCollegeValidation.getState(formState.validate)"
          >You must enter your other new college</b-form-invalid-feedback
        >
      </b-form-group>
      <b-form-group
        label="Other College Major:"
        v-if="formData.newMajor === 'Other College'"
      >
        <b-form-input
          :disabled="!formState.isEditing"
          :state="otherCollegeMajorValidation.getState(formState.validate)"
          v-model="formData.otherCollegeMajor"
          placeholder="enter your major"
        ></b-form-input>
        <b-form-invalid-feedback
          :state="otherCollegeMajorValidation.getState(formState.validate)"
          >You must enter your other college new major</b-form-invalid-feedback
        >
      </b-form-group>
      <b-form-group label="Why:">
        <b-form-textarea
          :disabled="!formState.isEditing"
          :state="reasonWhyValidation.getState(formState.validate)"
          v-model="formData.reasonWhy"
          placeholder="Enter something..."
          rows="3"
          max-rows="6"
        ></b-form-textarea>
        <b-form-invalid-feedback
          :state="reasonWhyValidation.getState(formState.validate)"
          >Please enter a reason for why you are changing
          majors</b-form-invalid-feedback
        >
      </b-form-group>
      <b-form-group label="Do you want to be contacted about this decision?">
        <b-form-checkbox
          :disabled="!formState.isEditing"
          v-model="formData.beContacted"
          name="checkbox-1"
          value="true"
          unchecked-value="false"
          >Yes</b-form-checkbox
        >
      </b-form-group>

      <b-form-group v-show="formState.isEditing">
        <b-button
          variant="primary"
          type="submit"
          class="red"
          :disabled="formState.submitting"
          ><b-spinner
            class="submitting-spinner"
            small
            v-if="formState.submitting"
          />
          {{ formState.submitting ? "Submitting..." : "Submit" }}</b-button
        >
      </b-form-group>
    </b-form>

    <div class="success-message" v-else>
      <p>Your message has been submitted</p>
    </div>
  </div>
</template>
<script>
import {
  BForm,
  BButton,
  BFormGroup,
  BFormCheckbox,
  BFormInput,
  BFormTextarea,
  BSpinner,
  BFormInvalidFeedback,
  BFormSelect
} from "bootstrap-vue";

import { IsNotEmptyString } from "./lib/Validation";

import MentorApplicationApi from "./lib/MentorApplicationApi";

export default {
  name: "ChangeMajorForm",
  components: {
    BForm,
    BButton,
    BFormGroup,
    BFormCheckbox,
    BFormInput,
    BFormTextarea,
    BFormInvalidFeedback,
    BSpinner,
    BFormSelect
  },
  computed: {
    changeMajorOptionsValue() {
      if ("undefined" !== typeof this.changeMajorOptions) {
        return this.changeMajorOptions.map(x => x.value).sort();
      } else {
        return [];
      }
    },
    changeCollegeOptionsValue() {
      if ("undefined" !== typeof this.changeCollegeOptions) {
        return this.changeCollegeOptions.map(x => x.value).sort();
      } else {
        return [];
      }
    },
    // broke validation out per-field, so that the entire fieldset is not re-validated when a single value is updated
    reasonWhyValidation() {
      return IsNotEmptyString(this.formData.reasonWhy);
    },
    newMajorValidation() {
      return IsNotEmptyString(this.formData.newMajor);
    },
    otherCollegeValidation() {
      return IsNotEmptyString(this.formData.otherCollege);
    },
    otherCollegeMajorValidation() {
      return IsNotEmptyString(this.formData.otherCollegeMajor);
    },
    hasValidationErrors() {
      // each field on the form has to be listed here in order for it to work
      let checklist = [this.reasonWhyValidation, this.newMajorValidation];
      if (this.formData.newMajor === "Other College") {
        checklist.push(
          this.otherCollegeValidation,
          this.otherCollegeMajorValidation
        );
      }

      return checklist.some(x => true !== x.isValid);
    }
  },
  data() {
    return {
      api: new MentorApplicationApi(this.apiRootUrl),
      formData: {
        beContacted: this.initialBeContacted,
        newMajor: this.initialNewMajor,
        otherCollege: this.initialOtherCollege,
        otherCollegeMajor: this.initialOtherCollegeMajor,
        reasonWhy: this.initialReasonWhy
      },
      formState: {
        submitted: false,
        submitting: false,
        validate: false,
        isEditing: this.isNew
      }
    };
  },
  props: {
    userId: String,
    initialNewMajor: String,
    initialOtherCollege: String,
    initialOtherCollegeMajor: String,
    initialReasonWhy: String,
    initialBeContacted: Boolean,
    changeMajorUrl: String,
    apiRootUrl: String,
    isNew: Boolean,
    changeMajorOptions: Array,
    changeCollegeOptions: Array
  },
  methods: {
    submitForm(e) {
      e.preventDefault();
      this.formState.validate = true;
      if (this.hasValidationErrors) {
        return;
      }
      this.formState.submitting = true;
      this.formState.isEditing = false;

      if (this.formData.newMajor !== "Other College") {
        this.formData.otherCollege = null;
        this.formData.otherCollegeMajor = null;
      }
      let that = this;
      this.api
        .changeMajor(
          this.userId,
          this.formData.newMajor,
          this.formData.reasonWhy,
          this.formData.beContacted === "true",
          this.formData.otherCollege,
          this.formData.otherCollegeMajor
        )
        .then(
          () => {
            that.formState.submitted = true;
            that.formState.submitting = false;
            that.formState.isEditing = true;
          },
          error => {
            that.formState.submitting = false;
            that.formState.isEditing = true;
            alert(
              `Unable to submit: ${
                null === error?.response?.data?.error
                  ? "unknown error"
                  : error.response.data.error
              }`
            );
          }
        )
        .catch(() => {
          alert(`Unknown error logging your submission`);
          that.formState.submitting = false;
          that.formState.isEditing = true;
        });
    },
    editing() {
      this.formState.isEditing = !this.formState.isEditing;
      this.formData.newMajor = this.initialNewMajor;
      this.formData.reasonWhy = this.initialReasonWhy;
      this.formData.beContacted = this.initialBeContacted;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.submitting-spinner {
  margin-right: 0.5rem;
  vertical-align: middle;
}
</style>
